<avi-confirmation
    size="lg"
    class="recommendation-dialog clr-wrapper"
    (onClose)="handleCancel()"
    headerText="{{ l10nKeys.recommendationHeader | vtranslate }}"
>
    <ng-container ngProjectAs="avi-confirmation_modal-content">
        <div class="recommendation-dialog__content-container">
            <logs-errors
                alertType="danger"
                [show]="showError$ | async"
                [errorMessage]="error"
            >
            </logs-errors>

            <div
                *ngIf="busy"
                class="recommendation-dialog__loader"
            >
                <clr-spinner clrMedium></clr-spinner>
            </div>
            <div *ngIf="!busy && !(showError$ | async)">
                <logs-errors
                    alertType="success"
                    [show]="isRecommendationAlreadyApplied$ | async"
                    [successMessageLabel]="l10nKeys.alreadyAppliedAlertMessage | vtranslate"
                ></logs-errors>
                <logs-errors
                    alertType="warning"
                    [show]="isRecommendationFailed$ | async"
                    [timeoutMessageLabel]="l10nKeys.failedAlertMessage | vtranslate"
                ></logs-errors>
                <logs-errors
                    alertType="warning"
                    [show]="isRecommendationLogNotAvailable$ | async"
                    [timeoutMessageLabel]="l10nKeys.logNotAvailableAlertMessage | vtranslate"
                ></logs-errors>
                <div *ngIf="isRecommendationGenerated()">
                    {{ l10nKeys.recommendationsMessage | vtranslate }}
                </div>
                <recommendation-grid [recommendationList]="recommendationList"></recommendation-grid>
            </div>
        </div>
    </ng-container>

    <ng-container ngProjectAs="avi-confirmation_modal-actions">
        <cds-button
            (click)="handleCancel()"
            action="outline"
        >
            {{ globalL10nKeys.cancelLabel | vtranslate }}
        </cds-button>
        <cds-button
            *ngIf="isRecommendationGenerated()"
            (click)="handleSubmit()"
            [loadingState]="loadingState"
        >
            {{ l10nKeys.acceptRecommendationButtonLabel | vtranslate }}
        </cds-button>
    </ng-container>
</avi-confirmation>
